import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  getParent,
  flow,
  types,
} from 'mobx-state-tree';
import { debug, request } from 'lib';
import FinanceModel from 'models/finance-model';

const log = debug.create('group');
const error = debug.create('group:error');

import { getGlobalStore } from 'stores';

const initState = {};

const UserGroupInfoModel = types.model('UserGroupInfoModel', {
  group_id: 0,
  intimate: 0,
  level: 0,
  style: 1,
  user_id: 0,
  timestamp: 0,
  _id: '',
});

const GroupInfoModel = types.model('GroupInfoModel', {
  // fans_list: {},
  // group_des: '',
  // group_name: '',
  intimate: 0,
  member_count: 0,
  describe: '',
  rank: '',
  reason: types.maybeNull(types.string),
  star_id: 0,
  // star_name: '',
  name: '',
  status: 1,
  timestamp: 0,
  _id: 0,
});

const Model = types
  .model('GroupModel', {
    info: types.maybeNull(GroupInfoModel),
    userGroupInfo: types.maybeNull(UserGroupInfoModel),
  })
  .views((self) => {
    return {
      get hasGroup() {
        return !!self.info;
      },
    };
  })
  .actions((self) => {
    const update = (info) => {
      self.info = info;
    };

    const loadUserGroupInfo = flow(function* () {
      // let {room: {roomId}} = getStore()
      // let res;
      // if(getGlobalStore().isLogin) {
      //   try {
      //     res = yield request.api.get(`lovegroupfans/user_group_info`, {
      //       token: true,
      //       room_id: roomId
      //     })
      //
      //     self.userGroupInfo = res.data
      //
      //   } catch (e) {
      //   }
      // }
    });

    return {
      init: loadUserGroupInfo,
      loadUserGroupInfo,
      update,
    };
  });

export default {
  initState,
  Model,
};
